import {Component, HostListener, OnInit} from '@angular/core';
import {Router, RouterOutlet} from '@angular/router';
import {UserService} from "./user/user.service";
import {UserStateService} from "./user/user.state.service";
import {DamHeaderComponent} from './dam-header/dam-header.component';
import {ActiveFiltersBarComponent} from './dam-header/active-filters-bar/active-filters-bar.component';
import {AssetDetailComponent} from './assets/asset-detail/asset-detail.component';
import {UploadComponent} from "./upload/upload.component";
import {ThemeService} from './common/theme.service';
import {environment} from "../environments/environment";
import {NavStatusService} from "./nav-status.service";
import {FormService} from "./home/m2app-form/form.service";
import {LocaleStorageService} from "./common/locale-storage.service";
import {TranslateService} from "@ngx-translate/core";
import {PdfViewerComponent} from "./assets/pdf-viewer/pdf-viewer.component";


@Component({
    selector: 'app-root',
    imports: [RouterOutlet, DamHeaderComponent, ActiveFiltersBarComponent, AssetDetailComponent, UploadComponent, PdfViewerComponent],
    templateUrl: './app.component.html',
    styleUrl: './app.component.scss',
})
export class AppComponent implements OnInit {
    title = 'mdb-frontend';
    messageTarget: any;
    messageOrigin: any;
    allowedLocales: string[] = ['en-GB', 'en-US', 'de-DE'];
    @HostListener('window:message', ['$event'])
    onMessage(event: any) {
        this.receiveMessage(event);
    }

    constructor(
        private userService: UserService,
        private userStateService: UserStateService,
        private themService: ThemeService,
        private router: Router,
        private navStateService: NavStatusService,
        private formService: FormService,
        private localStorageService: LocaleStorageService,
        private translate: TranslateService
    ) {
    }

    ngOnInit(): void {
        this.detectUserLanguage();
        this.themService.autoLoadTheme();
        //this.matIconReg.setDefaultFontSetClass('outlined')
        this.userService.getLoggedInUser().subscribe({
            next: (user) => {
                this.userStateService.userCallReady = true;
                this.userStateService.user = user;
            },
            error: (error) => {
                if (error && error.status === 401) {
                   //  console.info('User is not logged in');
                    this.userStateService.userCallReady = true;
                } else {
                   // console.error('Error loading user', error);
                    this.userStateService.userCallReady = true;
                }
            }
        });
    }
    receiveMessage(event: any) {
        if (!this.checkHostAllowed(event.origin)) {
            // console.error('origin', event.origin, 'is not whitelisted');
            return;
        }
        // console.log('event?', event);
        if (event.data && event.data.data && event.data.data.init.hasOwnProperty('path')) {
            this.navStateService.setIframeIntegrated(true);
            const url = event.data.data.init.path;
            this.router.navigate([url], {skipLocationChange: true}).then();
        }
        if (event.data && event.data.height) {
            this.formService.setIframeHeight(event.data.height);
        }
    }
    checkHostAllowed(origin: any): boolean {
        for (const host of environment.allowedHosts) {
            // console.log('host', host, 'origin', origin);
            if (origin.indexOf(host) !== -1) {
                return true;
            }
        }
        return false;
    }
    detectUserLanguage() {
        const lang = localStorage.getItem('userLanguage');
        console.log('local storage lang is', lang);
        if (lang) {
            this.translate.defaultLang = lang.replace(/"/g, "");
            this.translate.use(lang.replace(/"/g, ""));
            console.log('did set lang to', this.translate.defaultLang);
        } else {
            console.log('else');
            if (this.isAllowLocale(navigator.language)) {
                this.translate.setDefaultLang(navigator.language);
                this.localStorageService.setItem('userLanguage', navigator.language);
            } else {
                this.translate.setDefaultLang('en-GB');
                this.localStorageService.setItem('userLanguage', 'en-GB');
            }

        }
    }
    isAllowLocale(value: any): boolean {
        for (const loc of this.allowedLocales) {
            if (loc === value) {
                return true;
            }
        }
        return false;
    }
    sendMessage(data: any) {
        if (this.messageOrigin) {
            this.messageTarget.postMessage(data, this.messageOrigin);
        }
    }
}
